import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteTourPayload } from '@app-store/slices/tours/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeleteTourPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.tours.delete

function* deleteTourSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/event/tour/${payload.id}`)
        if (response.success) {
            yield put(onSuccess({ response: response.result }))
            if (payload?.sagaCB) {
                payload.sagaCB.onSuccess()
            }
            notification.success({
                message: 'Tour deleted successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure({ error, id: payload.id }))
    }
}

function* deleteTourSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteTourSagaTask)
}

export default deleteTourSaga
